import { APP_INITIALIZER, inject } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFrCa from '@angular/common/locales/fr-CA';
import localeFrCaExtra from '@angular/common/locales/extra/fr-CA';
import localeEnCa from '@angular/common/locales/en-CA';
import localeEnCaExtra from '@angular/common/locales/extra/en-CA';
import { HtmlLang } from '@sxm-util/angular/platform-browser';
import { queryParamsAsObject } from '@sxm-core/utility-code/typescript/browser-common-dom';

type Locales = 'en-CA' | 'en-US' | 'fr-CA';

export function provideLocale({
    locale,
}: {
    locale: {
        languages: {
            supported: Locales[];
            default: Locales;
        };
    };
}) {
    return [
        {
            provide: APP_INITIALIZER,
            useFactory: () => {
                const htmlLang = inject(HtmlLang);
                return () => {
                    locale.languages.supported.forEach((lang) => {
                        switch (lang) {
                            case 'en-CA':
                                registerLocaleData(localeEnCa, localeEnCaExtra);
                                break;
                            case 'fr-CA':
                                registerLocaleData(localeFrCa, localeFrCaExtra);
                                break;
                        }
                    });
                    // TODO: need to think about how to persist this in something like localstorage or a session cookie, etc
                    let localeToUse = locale.languages.default;
                    const queryParams = queryParamsAsObject();
                    const localeFromQueryParams = queryParams['locale'];
                    if (
                        localeFromQueryParams &&
                        locale.languages.supported.some(
                            (l) => l === localeFromQueryParams,
                        )
                    ) {
                        localeToUse = localeFromQueryParams as Locales;
                        // TODO: consider removing locale from query params at this point?
                    }

                    htmlLang.setHtmlLang(localeToUse);
                    htmlLang.setAvailableLangs(locale.languages.supported);
                };
            },
            multi: true,
        },
    ];
}
